import { useEffect } from 'react';
import TechItem from '../../common/TechItem';
import '../../Technology.css'

const Training = () => {

    useEffect(() => {
        document.title = 'Formación Séneca'
        window.scrollTo(0, 0)
    }, []);

    return (

        <TechItem
            title={'Formación Séneca'}
            imageURL={'/images/technology/tecnologia-6.jpg'}
            date={'18 agosto, 2016'}
            textArray={[
                "<p className='middle-section-label'>Desde Séneca queremos ofrecer el más completo software de gestión de contenidos audiovisuales. Se trata de una herramienta para facilitar la comunicación entre las instituciones y el ciudadano, que posibilitan la transmisión, de manera directa y sin intermediarios, del mensaje, la postura y la coherencia de cada una de las ideas. 20 años trabajando codo a codo con parlamentos, diputaciones y ayuntamientos nos han permitido compartir objetivos y aportar tecnologías que mejoran el trabajo de la administración institucional.</p>",
                "<p className='middle-section-label'>Esta experiencia nos ha permitido crear las mejores opciones para <a href='/funcionalidades/grabacion-y-catalogacion/'>grabación, catalogación</a>, mediateca en línea, transcripción y publicación. Pero, además, hemos sabido adaptarnos a los nuevos requerimientos normativos, incluyendo, por ejemplo, la opción de vídeo-acta, a través de la cual se puede gestionar la autenticidad e integridad del acta con la firma del Secretario mediante certificado digital o DNI-e, así como su validación pública.</p>",
                "<p className='middle-section-label'>Todo esto se ve complementado con una amplia oferta de formación, siempre adaptada a cada organización y cada situación. Desde el momento en el que se acuerda contratar nuestros servicios, nuestro equipo especializado inicia una tarea de acompañamiento. Realizamos un estudio exhaustivo de las necesidades particulares de cada caso y, a partir de sus resultados, desarrollamos sesiones formativas útiles y prácticas, diseñadas para alcanzar objetivos concretos y siempre encaminadas a que nuestros usuarios puedan sacar el mayor partido posible de nuestros productos.</p>"
            ]}
        />

    )

}

export default Training